import Dropdown from "components/inputs/dropdown";
import Typography from "components/typography";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { Packages } from "./package-data";
import PrimaryButton from "components/buttons/primary-button";
import api from "services/axiosInstance";
import Toast from "components/toast";
import { RefreshToken } from "services/refreshToken";
import { GetUser } from "services/user/getUser";
import { SetUserSubscription } from "services/user/setUser";

type PackageType = keyof typeof Packages;

interface IProps {
  isMonthly: boolean;
  ActivePackage: PackageType;
}
const SummaryCard = ({ isMonthly, ActivePackage }: IProps) => {
  const navigate = useNavigate();
  const ArtistNoList = ["1", "2", "3", "5", "10", "20", "50", "100"];

  const [artistNo, setArtistNo] = useState(
    ActivePackage === "independent" ? "1" : ActivePackage === "pro" ? "2" : "3"
  );

  const user = GetUser();

  const hasUser = useMemo(() => {
    if (user) {
      return true;
    }
    return false;
  }, []);

  const [activePackage, setActivePackage] =
    useState<PackageType>(ActivePackage);

  useEffect(() => {
    if (Number(artistNo) === Number("1")) {
      setActivePackage("independent");
    }
    if (Number(artistNo) === Number("2")) {
      setActivePackage("pro");
    }
    if (Number(artistNo) > Number("2")) {
      setActivePackage("label");
    }
  }, [artistNo]);

  const ChangePlan = async () => {
    try {
      await RefreshToken();
      const { data } = await api.post("/users/upgrade-plan", {
        newPlan: activePackage
      });

      localStorage.setItem("accessToken", data.newAccessToken);

      SetUserSubscription(activePackage);

      navigate("/overview");
    } catch (error) {
      Toast({ error: error });
    }
  };

  return (
    <Container>
      <HeaderContainer>
        <CardTitleArea>
          <Typography color={Colors.white100} size="3xl" weight="semibold">
            Summary
          </Typography>
          <Arrow onClick={() => navigate(-1)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M20 12H4M4 12L10 6M4 12L10 18"
                stroke="#FEA101"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Arrow>
        </CardTitleArea>
        <PackageIdentityContainer>
          <PackageIconContainer
            ispro={activePackage === "pro" ? "true" : "false"}
          >
            <PackageIcon>{Packages[activePackage].icon}</PackageIcon>
          </PackageIconContainer>
          <Typography size="lg" color={Colors.grey300}>
            {activePackage}
          </Typography>
        </PackageIdentityContainer>
      </HeaderContainer>
      <CardBody>
        <FeatureItem>
          <Feature>
            <FeatureIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M7.99992 6.66665C9.47268 6.66665 10.6666 5.47274 10.6666 3.99998C10.6666 2.52722 9.47268 1.33331 7.99992 1.33331C6.52716 1.33331 5.33325 2.52722 5.33325 3.99998C5.33325 5.47274 6.52716 6.66665 7.99992 6.66665Z"
                  stroke="#909090"
                />
                <path
                  d="M12 5.99996C13.1046 5.99996 14 5.25377 14 4.33329C14 3.41282 13.1046 2.66663 12 2.66663"
                  stroke="#909090"
                  stroke-linecap="round"
                />
                <path
                  d="M4 5.99996C2.89543 5.99996 2 5.25377 2 4.33329C2 3.41282 2.89543 2.66663 4 2.66663"
                  stroke="#909090"
                  stroke-linecap="round"
                />
                <path
                  d="M8 14C10.2091 14 12 12.8061 12 11.3333C12 9.86053 10.2091 8.66663 8 8.66663C5.79086 8.66663 4 9.86053 4 11.3333C4 12.8061 5.79086 14 8 14Z"
                  stroke="#909090"
                />
                <path
                  d="M13.3333 12.6666C14.5027 12.4102 15.3333 11.7607 15.3333 11C15.3333 10.2392 14.5027 9.58978 13.3333 9.33331"
                  stroke="#909090"
                  stroke-linecap="round"
                />
                <path
                  d="M2.66675 12.6666C1.49725 12.4102 0.666748 11.7607 0.666748 11C0.666748 10.2392 1.49725 9.58978 2.66675 9.33331"
                  stroke="#909090"
                  stroke-linecap="round"
                />
              </svg>
            </FeatureIcon>
            <Typography size="s">Number of Artist</Typography>
          </Feature>
          <DropdownItem>
            <Dropdown
              chosenItem={artistNo}
              items={ArtistNoList}
              selectItem={(value) => setArtistNo(value)}
            />
          </DropdownItem>
        </FeatureItem>
        <FeatureItem>
          <Feature>
            <FeatureIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M2 9.99997C2 11.8856 2 12.8284 2.58579 13.4142C3.17157 14 4.11438 14 6 14H10C11.8856 14 12.8284 14 13.4142 13.4142C14 12.8284 14 11.8856 14 9.99997"
                  stroke="#909090"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.99992 10.6666V1.99997M7.99992 1.99997L10.6666 4.91664M7.99992 1.99997L5.33325 4.91664"
                  stroke="#909090"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </FeatureIcon>
            <Typography size="s">Uploads</Typography>
          </Feature>
          <Typography>Unlimited</Typography>
        </FeatureItem>
        {Packages[activePackage].labelNames && (
          <FeatureItem>
            <Feature>
              <FeatureIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M8 9.99997C9.10457 9.99997 10 9.10454 10 7.99997C10 6.8954 9.10457 5.99997 8 5.99997C6.89543 5.99997 6 6.8954 6 7.99997C6 9.10454 6.89543 9.99997 8 9.99997Z"
                    stroke="#909090"
                  />
                  <path
                    d="M14.6337 8.66692C14.2992 12.0358 11.4568 14.6669 7.99992 14.6669C4.31802 14.6669 1.33325 11.6822 1.33325 8.00025C1.33325 4.54337 3.96437 1.701 7.33325 1.36652"
                    stroke="#909090"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10 7.99945V1.638C12.0734 2.28921 13.7103 3.92609 14.3615 5.99947"
                    stroke="#909090"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </FeatureIcon>
              <Typography size="s">Label Names</Typography>
            </Feature>
            <Typography>Unlimited</Typography>
          </FeatureItem>
        )}
        {Packages[activePackage].customReleaseDates && (
          <FeatureItem>
            <Feature>
              <FeatureIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M1.33325 7.99996C1.33325 5.4858 1.33325 4.22873 2.1143 3.44767C2.89535 2.66663 4.15243 2.66663 6.66659 2.66663H9.33325C11.8474 2.66663 13.1045 2.66663 13.8855 3.44767C14.6666 4.22873 14.6666 5.4858 14.6666 7.99996V9.33329C14.6666 11.8474 14.6666 13.1046 13.8855 13.8856C13.1045 14.6666 11.8474 14.6666 9.33325 14.6666H6.66659C4.15243 14.6666 2.89535 14.6666 2.1143 13.8856C1.33325 13.1046 1.33325 11.8474 1.33325 9.33329V7.99996Z"
                    stroke="#909090"
                  />
                  <path
                    d="M11.9999 10.6666H10.6666M10.6666 10.6666H9.33325M10.6666 10.6666V9.33331M10.6666 10.6666V12"
                    stroke="#909090"
                    stroke-linecap="round"
                  />
                  <path
                    d="M4.66675 2.66663V1.66663"
                    stroke="#909090"
                    stroke-linecap="round"
                  />
                  <path
                    d="M11.3333 2.66663V1.66663"
                    stroke="#909090"
                    stroke-linecap="round"
                  />
                  <path
                    d="M1.66675 5.99997H14.3334"
                    stroke="#909090"
                    stroke-linecap="round"
                  />
                </svg>
              </FeatureIcon>
              <Typography size="s">Custom Release Dates</Typography>
            </Feature>
            <Typography>Unlimited</Typography>
          </FeatureItem>
        )}
      </CardBody>
      <CardFooter>
        <CardFooterHeader>
          <Typography size="s" color={Colors.grey500}>
            Total Payment
          </Typography>
          <Typography>
            ${Number(Packages[activePackage].price).toLocaleString()}.00/
            {isMonthly ? "month" : "year"}
          </Typography>
        </CardFooterHeader>
        <PrimaryButton
          text={hasUser ? "Pay Now" : "Sign Up"}
          inset
          onClick={hasUser ? ChangePlan : () => navigate("/create-account")}
        />
      </CardFooter>
    </Container>
  );
};

export default SummaryCard;

const Container = styled.div`
  margin-top: 6.6rem;
  margin-left: auto;
  margin-right: auto;
  width: 65rem;
  border-radius: 0.8rem;
  border: 1px solid #4e4c44;
  background-color: rgba(30, 30, 30, 0.8);
  padding: 2.4rem;
  @media only screen and (max-width: 769px) {
    width: 100%;
    margin-top: 2.4rem;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  padding-bottom: 1.6rem;
`;

const CardTitleArea = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.6rem;
`;

const Arrow = styled.div`
  cursor: pointer;
  width: 2.4rem;
  height: 2.4rem;
`;
const PackageIdentityContainer = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
`;

const PackageIconContainer = styled.div<{ ispro: string }>`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.8rem;

  border-top: 1px solid
    ${(props) => (props.ispro === "true" ? "#ffe369" : "#A9A28C")};
  background: #0d0d0d;
  box-shadow: 0px 3px 3px 0px rgba(50, 50, 50, 0.5) inset;
`;
const PackageIcon = styled.div`
  width: 1.6rem;
  height: 1.6rem;
`;

const CardBody = styled.div`
  padding-top: 1.6rem;
  border-top: 1px solid #2b2b2b;
  border-bottom: 1px solid #2b2b2b;
`;

const FeatureItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.6rem;
  color: ${Colors.grey200};
`;

const Feature = styled.div`
  display: flex;
  align-items: center;
  color: ${Colors.grey500};
`;

const FeatureIcon = styled.div`
  margin-right: 1rem;
  width: 1.6rem;
  height: 1.6rem;
`;
const DropdownItem = styled.div`
  width: 6rem;
`;

const CardFooter = styled.div`
  padding-top: 1.8rem;
`;

const CardFooterHeader = styled.div`
  margin-bottom: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
